export const microActivityList = "MICROACTIVITY_LIST";
export const microActivityUniqueList = "MICROACTIVITY_UNIQUE_LIST";